









import { defineComponent, PropType } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { profileLinkPurchaseSubjectTypeMap } from "@/hooks/useProfileLinks";
import { $t } from "@/lib/i18nHelpers";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionProfileLink",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction>, required: true },
  },
  computed: {
    linkType() {
      return $t(
        "profileLink." +
          Object.entries(profileLinkPurchaseSubjectTypeMap).find(
            ([_, value]) => value === this.transaction.contentType
          )?.[0] ?? ""
      );
    },
  },
});
